<template>
  <el-row>

      <el-card class="box-card" style="width: 500px;">

        <el-form ref="form" :model="form" label-width="80px">
          <el-row>
            <el-col :span="12">
              <el-form-item label="加人数量">
                <el-input v-model="form.addCount" clearable></el-input>
              </el-form-item>

            </el-col>
            <el-col :span="12">
              <el-form-item label="加人间隔">
                <el-input v-model="form.addWait" clearable></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-form-item label="申请话术">
              <el-input type="textarea" :rows="10" v-model="form.authMsg" placeholder="一行一句话,随机抽取" style="width: 100%"></el-input>
              <el-tag type="info">提示：一行一句话,随机抽取</el-tag>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="其他设置" >
              <el-col :span="12">
                <el-form-item label="">
                  <el-col :span="10" style="margin-bottom: 5px;margin-left: 10px">
                    <el-checkbox v-model="form.airMode">换号时切换飞行模式</el-checkbox>
                  </el-col>
                </el-form-item>
              </el-col>
            </el-form-item>

          </el-row>

        </el-form>
        <el-row>
          <el-button type="primary" @click="setConfig">保存设置</el-button>
        </el-row>
      </el-card>

  </el-row>
</template>

<script>
export default {
  data() {
    return{
      userName : window.sessionStorage.getItem('account'),
      form:{
        configLab:'配置1',
        addCount:15,
        addWait:5,
        airMode:true,
        authMsg:"",
      }
    }
  },
  created() {
    this.getDefaultConfig();
  },
  methods:{
    async setConfig(){
      if (!this.userName) {
        this.$msgNot.error('登录状态异常,请重新登录');
        return;
      }

      const {data:res} = await this.$ajax.post("/api/config/setConfig",{'account':this.userName,'data':this.form});
      if (res.code === 200){

      }
      this.$msgNot.success(res.msg);
    },
    async getDefaultConfig() {
      if (!this.userName) {
        this.$msgNot.error('登录状态异常,请重新登录');
        return;
      }

      const {data: res} = await this.$ajax.post("/api/config/getConfig", {'account': this.userName});
      if (res.code === 200) {
        // this.$msgNot.success(res.msg);
        this.form = res.data;

      } else {
        this.$msgNot.error(res.msg);
      }
    }
  }
}
</script>

<style scoped>

</style>
